import React from 'react';

const ContactUsSection = () => {
  return (
    <main className="relative max-w-[1200px] mx-auto px-4 md:px-10 py-10 md:py-20 z-10">
      <h2 className="text-[#7B54A2] text-[24px] sm:text-[26px] md:text-[30px] font-bold leading-8 sm:leading-10 ">
        By addressing a wide range of conditions and utilizing play-based
        interventions, Guidepost Pediatric physical therapists create a positive
        and engaging environment for children to thrive and reach their full
        physical potential. If you believe your child may benefit from pediatric
        physical therapy, contact us today!
      </h2>
    </main>
  );
};

export default ContactUsSection;
